import React, { useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import numeral from "numeral";

const options = {
  maintainAspectRatio: false,
  responsive: true,
  interaction: {
    mode: 'index'
  },
  stacked: false,
  legend: {
    display: true,
    position: 'top',
    onHover: function(e) {
      e.target.style.cursor = 'pointer';
   },
   hover: {
    onHover: function(e) {
       var point = this.getElementAtEvent(e);
       if (point.length) e.target.style.cursor = 'pointer';
       else e.target.style.cursor = 'default';
    }
 }
  },
  title: {
    display: false,
    text: 'Historical View'
  },
  elements: {
    point: {
      radius: 0,
    },
  },
  tooltips: {
    mode: "label",
    intersect: false,
    callbacks: {
      label: function (tooltipItem, data) {
        return numeral(tooltipItem.value).format("+0,0");
      },
    },
  },
  scales: {
    xAxes: [
      {
        display: true,
        gridLines: {
          display: true,
        },
        type: "time",
        time: {
          format: "MM/DD/YY",
          tooltipFormat: "ll",
        },
      },
    ],
    yAxes: [
      {
        type: 'linear',
        display: true,
        position: 'left',
        id: 'y-axis-1',
        gridLines: {
          display: false,
        },
        labels: {
          show: true
        },
        ticks: {
          min: 0,
          // Include a dollar sign in the ticks
          callback: function (value, index, values) {
            return numeral(value).format("0a");
          },
        },
      },
      // {
      //   type: 'linear',
      //   display: true,
      //   position: 'right',
      //   id: 'y-axis-2',
      //   gridLines: {
      //     display: false,
      //   },
      //   labels: {
      //     show: true
      //   },
      //   ticks: {
      //     // Include a dollar sign in the ticks
      //     callback: function (value, index, values) {
      //       return numeral(value).format("0a");
      //     },
      //   },
      // },
    ],
  },
};

const buildChartData = (data, casesType, countrySelected, diff="no", setpastCases, setpastRecovered, setpastDeaths) => {
  let chartData = [];
  if(diff === "no"){
    if(countrySelected === 'worldwide'){
      for (let date in data.cases) {
        chartData.push({
          x: date,
          y: data[casesType][date],
        });
        // console.log(Object.keys(data.cases)[Object.keys(data.cases).length-2]);
        // console.log(data[casesType][Object.keys(data.cases)[Object.keys(data.cases).length-2]] - data[casesType][Object.keys(data.cases)[Object.keys(data.cases).length-3]]);
      }
      // console.log(data[casesType][Object.keys(data.cases)[Object.keys(data.cases).length-1]] - data[casesType][Object.keys(data.cases)[Object.keys(data.cases).length-2]]);
    }
    else{
      for (let date in data.timeline.cases) {
        chartData.push({
          x: date,
          y: data["timeline"][casesType][date],
        });
      }
    }
  }
  else{
    let lastDataPoint;
    if(countrySelected === 'worldwide'){
      for (let date in data.cases) {
        if (lastDataPoint) {
          chartData.push({
            x: date,
            y: data[casesType][date] - lastDataPoint,
          });
        }
        lastDataPoint = data[casesType][date];
      }
    }
    else{
      for (let date in data.timeline.cases) {
        if (lastDataPoint) {
          chartData.push({
            x: date,
            y: data["timeline"][casesType][date] - lastDataPoint,
          });
        }
        lastDataPoint = data["timeline"][casesType][date];
      }
    }
    if(casesType === "cases"){
      setpastCases([chartData[chartData.length - 1].y, chartData[chartData.length - 2].y])
    }
    if(casesType === "recovered"){
      setpastRecovered([chartData[chartData.length - 1].y, chartData[chartData.length - 2].y])
    }
    if(casesType === "deaths"){
      setpastDeaths([chartData[chartData.length - 1].y, chartData[chartData.length - 2].y])
    }
  }
  return chartData;
};

function CentredChart({ casesType, countrySelected, diff, setpastCases, setpastRecovered, setpastDeaths }) {
  const [dataNew, setDataNew] = useState({});
  const [dataRecovered, setDataRecovered] = useState({});
  const [dataDeaths, setDataDeaths] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const url = countrySelected === 'worldwide' ? 'https://disease.sh/v3/covid-19/historical/all?lastdays=260'
                                            : `https://disease.sh/v3/covid-19/historical/${countrySelected}?lastdays=260`

      await fetch(url)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          let chartDataNew = buildChartData(data, "cases", countrySelected, diff, setpastCases, setpastRecovered, setpastDeaths);
          setDataNew(chartDataNew);
          
          let chartDataRecovered = buildChartData(data, "recovered", countrySelected, diff, setpastCases, setpastRecovered, setpastDeaths);
          setDataRecovered(chartDataRecovered);

          let chartDataDeaths = buildChartData(data, "deaths", countrySelected, diff, setpastCases, setpastRecovered, setpastDeaths);
          setDataDeaths(chartDataDeaths);
        });
    };

    fetchData();
  }, [casesType, countrySelected, diff, setpastCases, setpastRecovered, setpastDeaths]);

  return (
    <div>
      {dataNew?.length > 0 && dataRecovered?.length && dataDeaths?.length > 0  &&(
        <Line class
          data={{
            datasets: [
              {
                label: 'New Cases',
                type: 'line',
                data: dataNew,
                fill: false,
                borderColor: "#CC1034",
                backgroundColor: "rgba(204, 16, 52, 0.5)",
                yAxisID: 'y-axis-1'
              },
              {
                label: 'Recovered',
                type: 'line',
                data: dataRecovered,
                fill: false,
                backgroundColor: "#ACFD2F",
                borderColor: "#ACFD2F",
                yAxisID: 'y-axis-1'
              },
              {
                label: 'Deaths',
                type: 'line',
                data: dataDeaths,
                fill: false,
                backgroundColor: "#6c757d",
                borderColor: "#6c757d",
                yAxisID: 'y-axis-1'
              },
            ],
          }}
          options={options}
        />
      )}
    </div>
  );
}

export default CentredChart;